import * as React from 'react';
import {ReactComponent as Eye} from '../assets/eye.svg';
import {InputMask, MaskOptions} from '@react-input/mask';

interface Props extends React.InputHTMLAttributes<HTMLInputElement>, MaskOptions {
    label: string;
    sensitive?: boolean;
}

export const Input = (props: Props) => {
    const {label, type, mask, replacement, className, sensitive, ...rest} = props;
    const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);
    const actualType =
        type === 'password'
            ? isPasswordVisible
                ? 'text'
                : 'password'
            : type || 'text';

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prev) => !prev);
    };

    return (
        <label className="block font-bold relative">
            {label}
            <div className="mt-1 w-full flex items-center relative">
                {mask ? (
                    <InputMask
                        mask={mask}
                        replacement={replacement}
                        type={actualType}
                        className={`placeholder-tertiary font-normal text-14 bg-transparent border border-border rounded-full w-full outline-none pr-20 pl-4 py-2 h-10 ${className}`}
                        data-sensitive={sensitive ? 'true' : undefined}
                        {...rest}
                    />
                ) : (
                    <input
                        type={actualType}
                        className={`placeholder-tertiary font-normal text-14 bg-transparent border border-border rounded-full w-full outline-none pr-20 pl-4 py-2 h-10 ${className}`}
                        data-sensitive={sensitive ? 'true' : undefined}
                        {...rest}
                    />
                )}

                {type === 'password' && (
                    <div
                        className="absolute right-0 px-4 cursor-pointer flex items-center justify-center h-full"
                        onClick={togglePasswordVisibility}
                        aria-label={isPasswordVisible ? 'Esconder senha' : 'Mostrar senha'}
                        role="button"
                        tabIndex={0}
                    >
                        <Eye className={`w-4 h-4 ${isPasswordVisible ? 'fill-primary' : 'fill-tertiary'}`}/>
                    </div>
                )}
            </div>
        </label>
    );
};